import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const links = [
  { label: "Il Corso", href: "#programma" },
  { label: "Destinatari", href: "#destinatari" },
  { label: "Requisiti", href: "#requisiti" },
  { label: "Prezzo", href: "#prezzo" },
  { label: "FAQ", href: "#faq" },
  { label: "Contatti", href: "#contatti" },
];

export default function Header() {
  return (
    <motion.header
      initial={{ y: -64, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className="fixed inset-x-0 top-0 z-50 border-b border-line/70 bg-white/80 backdrop-blur-xl"
      data-testid="site-header"
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 sm:px-6 lg:px-8">
        <button
          onClick={() => scrollToId("#hero")}
          className="flex items-center gap-3 text-left"
          data-testid="header-logo"
        >
          <img
            src="/logo-anas.png"
            alt="Logo ANAS Milano Formazione"
            className="h-10 w-10 rounded-full object-cover"
            data-testid="header-logo-image"
          />
          <span className="leading-tight">
            <span className="block font-heading text-sm font-bold tracking-tight text-navy">ANAS Milano</span>
            <span className="block font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">Formazione · Corso SAB</span>
          </span>
        </button>

        <nav className="hidden items-center gap-6 lg:flex" data-testid="header-nav">
          {links.map((l) => (
            <button
              key={l.href}
              onClick={() => scrollToId(l.href)}
              className="text-sm font-medium text-slate-600 transition-colors hover:text-navy"
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="tel:+393513937976"
            className="hidden items-center gap-2 border border-line bg-white px-4 py-2 text-sm font-semibold text-navy transition-colors hover:bg-navy hover:text-white md:flex"
            data-testid="header-phone-link"
          >
            <Phone className="h-4 w-4" />
            +39 351 393 7976
          </a>
          <button
            onClick={() => scrollToId("#iscriviti")}
            className="bg-brand-amber px-5 py-2 text-sm font-bold text-white transition-colors hover:bg-navy hover:text-white"
            data-testid="header-cta-button"
          >
            Richiedi Info
          </button>
        </div>
      </div>
    </motion.header>
  );
}
